module.exports = __webpack_public_path__ + "static/DSC_9502-98bb428224fa7f512b70ee2d4c9efb65.jpg";